import handleCheckboxes from './components/handleCheckboxes'

const form = document.querySelector('#filter-productions');

if (form) {
  form.addEventListener('submit', (e) => {
    e.preventDefault();

    const params = new URLSearchParams();

    const start = form.querySelector('#start-date')?.value || '';
    const end = form.querySelector('#end-date')?.value || '';
    const dateValue = [start, end].filter(Boolean).join(',');
    if (dateValue) params.set('filter-date', dateValue);

    const themes = [...form.querySelectorAll('input[name="filter-themes"]:checked')]
      .map(i => i.value)
      .join(',');
    if (themes) params.set('filter-themes', themes);

    const territoires = [...form.querySelectorAll('input[name="filter-territoires"]:checked')]
      .map(i => i.value)
      .join(',');
    if (territoires) params.set('filter-territoires', territoires);

    const action = form.getAttribute('action') || window.location.pathname;
    window.location.href = `${action.split('?')[0]}?${params.toString()}`;
  });
}

const dateLabels = document.querySelectorAll('.date-label');

if (dateLabels.length > 0) {
  for (const dateLabel of dateLabels) {
    const decoration = dateLabel.querySelector('span')
    const input = dateLabel.querySelector('input');

    if (input.value !== '') {
      decoration.style.display = 'none';
    }

    input.addEventListener('focus', () => {
      decoration.style.display = 'none';
    })

    input.addEventListener('focusout', () => {
      if (input.value === '') {
        decoration.style.display = 'flex';
      }
    })
  }
}

const filterTheme = document.querySelector('.filter.themes');
const filterTerritory = document.querySelector('.filter.territoires');

if (filterTheme) {
  const terms = filterTheme.querySelectorAll('.term');
  handleCheckboxes(terms)
}

if (filterTerritory) {
  const terms = filterTerritory.querySelectorAll('.term');
  handleCheckboxes(terms)
}

const filterToggler = document.querySelector('#filter-toggler');
const filterProductions = document.querySelector('#filter-productions');

if (filterToggler && filterProductions) {
  filterToggler.addEventListener('click', () => {
    filterProductions.classList.toggle('open');
  })
}
